export interface CSVBoxMethods {
  onData?: (result:boolean, data:any) => void;
}
